import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { App as AntdApp, ConfigProvider } from 'antd'
import zhCN from 'antd/locale/zh_CN'
import type { ReactNode } from 'react'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
})

if (import.meta.env.DEV && typeof window !== 'undefined') {
  ;(window as Window & { __QUERY_CLIENT__?: QueryClient }).__QUERY_CLIENT__ = queryClient
}

// Ant Design 主题配置：安静、紧凑、运营工具风格
const themeConfig = {
  token: {
    colorPrimary: '#1677ff',
    borderRadius: 4,
    fontSize: 13,
  },
  components: {
    Table: {
      cellPaddingBlock: 6,
      cellPaddingInline: 12,
    },
    Card: {
      paddingLG: 16,
    },
  },
}

export default function AppProviders({ children }: { children: ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      <ConfigProvider locale={zhCN} theme={themeConfig}>
        <AntdApp>{children}</AntdApp>
      </ConfigProvider>
    </QueryClientProvider>
  )
}
